export enum SelectableRows {
  MULTIPLE = "multiple",
  SINGLE = "single",
  NONE = "none"
}
